import { locationPageCrumbs } from "../structured-data-core";
import { serviceAreaSchema } from "./service-area";

export function getCincinnatiStructuredData() {
  const url = "https://restorehair.com/locations/ohio/cincinnati/";
  const description =
    "Find out about your hair transplant options in Cincinnati with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    serviceAreaSchema("cincinnati", url, description),
    locationPageCrumbs(url, "Cincinnati"),
  ];
}
